export const formatUserLabel = (user) => {
  if (!user) return "—";
  const name = `${user.name || ""} ${user.lastName || ""}`.trim();
  const email = user.email?.emailId || user.email || "";
  return name ? `${name}${email ? ` (${email})` : ""}` : email || user._id;
};

export const INTERNAL_OPTIONS = [
  { value: "false", label: "Client users" },
  { value: "true", label: "Internal users" },
  { value: "all", label: "All users" },
];

export const FilterField = ({ label, children }) => (
  <div className="filter_field">
    <label>{label}</label>
    {children}
  </div>
);

export const queryErrorMessage = (err) =>
  err?.response?.data?.message || err?.message || "Something went wrong. Please try again.";

export const storedIsInternal = () => {
  try {
    return Boolean(JSON.parse(localStorage.getItem("flowedit:user") || "null")?.isInternal);
  } catch {
    return false;
  }
};

export const isBstBatch = (batch) =>
  Boolean(batch?.fluidSegregation || batch?.source?.sourceCode === "BST");

export const canDownloadBatchOutput = (batch) =>
  Boolean(batch && !isBstBatch(batch) && batch.stage === "review");
